import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";


import EmptyBox from "@/assets/icons/PointsEmptyBox.svg";
import Pagination from "../../order/components/pagination";


import styles from './index.module.scss';

import { PointItem } from "@/app/csr-src/apis/points/index.api";
import { fetchGetPointsBalance, fetchGetPointsQuery } from "@/app/csr-src/apis/points/points.api";
import UKPageError from "@/components/UKPageError";
import UKPageLoading from "@/components/UKPageLoading";
import UKPageNothing from "@/components/UKPageNothing";
import { getDpUrl } from "@/utils/goto";
import dayjs from "dayjs";
import { useRouter } from "next/navigation";
import { useNavigate } from "react-router-dom";
import UKDrawerHelp from "@/components/UKDrawerHelp";

const Points = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const router = useRouter();
  const [isNothing, setIsNothing] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pointTotal,setPointTotal] =useState<number>(0);
  const [priceUnit,setPriceUnit]=useState('');
  const [price,setPrice]=useState<number>(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const size=10
  const handleClose = () => {
    setOpenDrawer(false);
  };
  const [page, setPage] = useState({
    pageSize: size, 
    currentPage: 1,//当前页
  });
  const [dataDate, setDataDate] = useState<PointItem[]>([]);
  const [total, setTotal] = useState(0); // 总条数

  //获取积分和对应钱
  const getPointsBalance = async () => {
    try {
    const {code,data}=await fetchGetPointsBalance({
      pointsType:1001
    })
    if (code === 200&&data) {
      setPointTotal(data?.balance );
      setPriceUnit(data?.amountStr);
      setPrice(data?.amount)
    }
  } catch (err) {
    console.log(err)
  }
  
 }
 //点击T&C’s弹窗
 const onHandleHelp=()=>{
  setOpenDrawer(true)
}
  // 分页change事件
  const pagesChangeHandler = (pageNum: number) => {
    // window.scrollTo(0, 0); // 滚动到顶部
    setPage({
      ...page,
      pageSize: size,
      currentPage: pageNum,
    });
    // setTotal(0);
  };

  const getPointsData = async () => {
    setIsLoading(true);
    setIsError(false);
    const { pageSize, currentPage } = page;
    const params = {
      pageSize,
      pageNo:currentPage,
    };

    const { code, data } = await fetchGetPointsQuery(params); 
    if (code === 200) {
      if (data && Array.isArray(data.data) && data.data.length > 0) {
        setTotal(data?.total);
        setIsNothing(false);
        setIsLoading(false);
        setDataDate(data.data)
      } else {
        setIsNothing(true);
        
      }
      setIsError(false);
    } else {
      setIsError(true);
    }
    setIsLoading(false);
  };

  //跳转订单
  const handleOrder =(orderId:string)=>{
    navigate('/profile/my-orders/order-details?&isBack=true&orderId=' + orderId);
  }
  useEffect(() => {
    getPointsBalance();
  }, []);
  useEffect(() => {
    getPointsData();
    getPointsBalance();
  }, [page]);
  
  return (
    <div className={styles.pointPage}>
      <Helmet>
        <title>{t("points.title1")} | Joybuy</title>
        <meta name="description" content={t("seo.description.allDesc")} />
      </Helmet>
      <div className={styles.pointTitle}>
        <div className={styles.title}>{t("points.title1")}</div>
        <span onClick={onHandleHelp} className={styles.help}>T&C’s</span>
      </div>
      <div className={styles.pointInfo}>
        <div className={styles.pointFlex}>
            <div className={styles.pointInfoBlock}>
                <p className={styles.title}>{t("points.havePoint")}</p>
                <p className={styles.text}><span className="pointInfo-total">{pointTotal||0}</span>{t("points.points")}</p>
            </div>
            {price!==0&&
            <div className={styles.pointInfoBlock}>
                <p className={styles.title}>{t("points.spend")}</p>
                <p className={styles.text}><span className="pointInfo-coast">{priceUnit}</span>{t('points.toSpend')}</p>
            </div>
            }
        </div>
        
      </div>
      <div className={styles.pointContent}>
        <div className={styles.pointContentTitle}>
            <h2>{t("points.transactions")}</h2>
        </div>
      
      {isNothing && (
        <div className={styles.errorPage}>
          <UKPageNothing style={{ marginTop: "60px" }} />
        </div>
      )}
      {isError && (
        <div className={styles.errorPage}>
          <UKPageError style={{ marginTop: "60px" }} clickTryAgain={() => getPointsData()} />
        </div>
      )}
      {isLoading && (
        <div className={styles.errorPage}>
          <UKPageLoading />
        </div>
      )}
     
      {!isNothing && !isError && !isLoading && (
        <div className={styles.painList}> 
          {dataDate && JSON.stringify(dataDate) !== "{}" ? (
           
            <div className={styles.itemList}>
              {dataDate.map((item: any, index: number) => {
                return (
                  <div
                    className={`${styles.item} ${item.transType === 2003 ? styles.disabled : ''}`}
                    key={index}
                  >
                    <div className={styles.itemLeft}>
                      <p
                        className={styles.itemOrder}
                        onClick={() => handleOrder(item?.businessBill1)}
                      >
                        {item?.businessBill1&&item?.businessBill1FieldName}
                        <span className={styles.pointsWeight}>{item?.businessBill1}</span>
                        {/* <span className={styles.pointsWeight}>{item?.amountLong}</span> */}
                      </p>
                      <p className={styles.itemTime}>
                        {item.transType===1001&&(
                         <p>
                            <span className={styles.m4}>{item.orderTimeFieldName}</span>
                            <span className={styles.m4}>{item?.beginTimeStr}</span>
                            <span className={styles.m4}>{item?.expireFieldName}</span>
                            <span className={styles.m4}>{item?.endTimeStr}</span>
                         </p>
                        )}
                        {item.transType===1002&&(
                         <p>
                            <span className={styles.m4}>{item?.amount>0?item.orderTimeFieldName:item?.title}</span>
                            <span className={styles.m4}> {item.createDateStr}</span>
                         </p>
                        )}
                         {item.transType===1003&&(
                         <p>
                            <span className={styles.m4}> {item?.amount>0?item.orderTimeFieldName:item?.title}</span>
                            <span className={styles.m4}>{item?.createDateStr}</span>
                         </p>
                        )}
                        {/* 交易相关积分抵扣  消费积分 扣（交易） */}
                        {item.transType===2001&&(
                         <p>
                            <span className={styles.m4}> {item?.amount>0?item.orderTimeFieldName:item?.title}</span>
                            <span className={styles.m4}> {item?.createDateStr}</span>
                         </p>
                        )}
                        {/* 发积分退回 */}
                        {item.transType===2012&&(
                         <p>
                            <span className={styles.m4}>{item?.amount>0?item.orderTimeFieldName:item?.title}</span> 
                            <span className={styles.m4}>{item?.createDateStr}</span>
                         </p>
                        )}
                        {/* 过期时间 */}
                        {item.transType===2003&&
                        <p>
                          <span className={styles.m4}>  {item?.title}</span>
                          <span className={styles.m4}> {item?.createDateStr}</span>
                        </p>}
                      </p>
                    </div>
                    <div className={styles.itemRight}>
                    {item?.amount>0 ?
                     <p className={`${styles.itemNumber} ${styles.pointBlue}`}>{item?.amountStr}
                      <p className={styles.itemUnit}>{item?.pointsTypeRemark}</p>
                      </p>:
                      <>
                      <p className={`${styles.itemNumber} ${styles.pointRed}`}>{item?.amountStr}</p>
                      <p className={styles.itemUnit}>{item?.pointsTypeRemark}</p>
                     </>
                    }
                       
                    </div>
                </div>
                )
                
                })}
                <div className={styles.paginationWrap}>
                  <Pagination currentPage={page.currentPage} totalPages={Math.ceil(total / page.pageSize)} handlePageChange={pagesChangeHandler} />
                </div>
            </div>
           ) : (
            <div className={styles.emptyBox}>
              <EmptyBox className={styles.emptyBoxIcon} />
              <div className={styles.emptyContent}>
                <p className={styles.emptyBoxMsg}>{ t("points.nothing")}</p>
                <p className={styles.emptyBoxMsg}>{t("points.nothingMore")}</p>
              </div>
            </div>
          )} 
        </div>
      )}
      </div>
      {openDrawer&&<UKDrawerHelp
        id="points-terms-and-conditions"
        openDrawer={openDrawer}
        handleClose={handleClose}
      ></UKDrawerHelp>
}
    </div>
  );
};
export default Points;
